import React, { FunctionComponent } from "react";

import { useSearchAccessoriesByVehicle } from "../../../queries/useSearchAccessoriesByVehicle";
import { FiltersPanel } from "../../FiltersSidebar/FiltersPanel";
import { Category } from "./Category/Category";
import { Criteria } from "./Criteria/Criteria";

export const AccessoryFilters: FunctionComponent<{ onClose(): void }> = ({
  onClose,
}) => {
  const { isLoading } = useSearchAccessoriesByVehicle({
    keepPreviousData: true,
  });
  return (
    <FiltersPanel loading={isLoading} onClose={onClose}>
      <Criteria />
      <Category />
    </FiltersPanel>
  );
};

/**
 * @see docs/worklog/TW-891/TW-891-standalone-accessories-site/rfc.md
 * @see docs/worklog/TW-891/TW-891-standalone-accessories-site/tfc.md
 */
